!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("colorutil", [], e) : "object" == typeof exports ? exports.colorutil = e() : t.colorutil = e();
}(this, function () {
  return function (t) {
    function e(n) {
      if (r[n]) return r[n].exports;
      var a = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(a.exports, a, a.exports, e), a.l = !0, a.exports;
    }
    var r = {};
    return e.m = t, e.c = r, e.i = function (t) {
      return t;
    }, e.d = function (t, r, n) {
      e.o(t, r) || Object.defineProperty(t, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, e.n = function (t) {
      var r = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(r, "a", r), r;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "/", e(e.s = 26);
  }([function (t, e, r) {
    "use strict";

    var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      },
      a = function () {
        function t(t, e) {
          var r = [],
            n = !0,
            a = !1,
            u = void 0;
          try {
            for (var o, i = t[Symbol.iterator](); !(n = (o = i.next()).done) && (r.push(o.value), !e || r.length !== e); n = !0);
          } catch (t) {
            a = !0, u = t;
          } finally {
            try {
              !n && i.return && i.return();
            } finally {
              if (a) throw u;
            }
          }
          return r;
        }
        return function (e, r) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return t(e, r);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }();
    t.exports = new function () {
      var t = this;
      this.noop = function () {}, this.get = function (e, r, n) {
        var a = Array.isArray(r) ? r : r.split(".");
        if (!a.length) return e;
        var u = a.shift();
        return e && e.hasOwnProperty(u) ? t.get(e[u], a, n) : n;
      }, this.has = function (e, r) {
        var n = Array.isArray(r) ? r : r.split(".");
        if (!n.length) return !0;
        var a = n.shift();
        return !(!e || !e.hasOwnProperty(a)) && t.has(e[a], n);
      }, this.set = function (e, r, n) {
        var a = Array.isArray(r) ? r : r.split("."),
          u = a.shift();
        if (!a.length) return void (e[u] = n);
        if (!e.hasOwnProperty(u)) {
          var o = a[0];
          e[u] = t.isNumeric(o) ? [] : {};
        }
        t.set(e[u], a, n);
      }, this.clone = function (t) {
        return JSON.parse(JSON.stringify(t));
      }, this.includes = function (t, e) {
        if (Array.isArray(t)) return t.indexOf(e) > -1;
        var r = !0,
          n = !1,
          u = void 0;
        try {
          for (var o, i = Object.entries(t)[Symbol.iterator](); !(r = (o = i.next()).done); r = !0) {
            var l = a(o.value, 2);
            l[0];
            if (e === l[1]) return !0;
          }
        } catch (t) {
          n = !0, u = t;
        } finally {
          try {
            !r && i.return && i.return();
          } finally {
            if (n) throw u;
          }
        }
        return !1;
      }, this.isObject = function (t) {
        return null !== t && "object" === (void 0 === t ? "undefined" : n(t)) && !Array.isArray(t);
      }, this.isNumber = function (t) {
        return "number" == typeof t && !isNaN(t);
      }, this.isNumeric = function (t) {
        return !isNaN(parseInt(t));
      };
      var e = function (e) {
        var r = e,
          n = Array.isArray(e) && 1 === e.length || "string" == typeof e,
          a = Array.isArray(e) && e.length > 1;
        if (n) {
          var u = Array.isArray(e) ? e[0] : e;
          r = function (e, r) {
            return t.has(e, u);
          };
        } else a && (r = function (r, n) {
          return t.get(r, e[0]) === e[1];
        });
        return r;
      };
      this.findIndex = function (t, r, n) {
        n = n || 0;
        var a = e(r);
        n < 0 && (n = t.length + n);
        for (var u = n; u < t.length; u++) if (a(t[u], u)) return u;
        return -1;
      }, this.findLastIndex = function (r, n, a) {
        a = t.isNumber(a) ? a : r.length - 1;
        var u = e(n);
        a < 0 && (a = r.length + a);
        for (var o = a; o > -1; o--) if (u(r[o], o)) return o;
        return -1;
      }, this.find = function (e, r, n) {
        return e[t.findIndex(e, r, n)];
      }, this.findLast = function (e, r, n) {
        return e[t.findLastIndex(e, r, n)];
      }, this.findPropertyIndex = function (e, r) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        return t.findIndex(e, function (e) {
          return t.has(e, r);
        }, n);
      }, this.findLastPropertyIndex = function (e, r, n) {
        return n = n || e.length - 1, t.findLastIndex(e, function (e) {
          return t.has(e, r);
        }, n);
      }, this.pull = function (t, e) {
        var r = void 0;
        if (t) for (; t.indexOf(e) > -1;) (r = t.indexOf(e)) > -1 && t.splice(r, 1);
      }, this.lowerFirst = function (t) {
        return t ? t.charAt(0).toLowerCase() + t.substring(1) : t;
      }, this.forEach = function (t, e) {
        for (var r = 0; r < t.length; r++) {
          e(t[r], r);
        }
      }, this.map = function (e, r) {
        for (var n = [], a = 0; a < e.length; a++) {
          var u = e[a];
          "string" == typeof r ? n.push(t.get(u, r)) : n.push(r(u, a));
        }
        return n;
      }, this.keys = function (t) {
        return t ? Object.keys(t) : [];
      }, this.sortBy = function (t, e) {
        return Array.isArray(t) ? t.sort(function (t, r) {
          var n = t[e],
            a = r[e];
          return void 0 === n ? 1 : void 0 === a ? -1 : n < a ? -1 : n > a ? 1 : 0;
        }) : t;
      };
    }();
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      },
      u = r(2),
      o = n(u),
      i = r(3),
      l = n(i),
      s = r(7),
      f = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
      },
      c = new function () {
        var t = this;
        this.name = "rgb", this.className = "Rgb", this.parent = null, this.test = function (t) {
          return null !== t && "object" === (void 0 === t ? "undefined" : a(t)) && t.hasOwnProperty("r") && t.hasOwnProperty("g") && t.hasOwnProperty("b") && t.r >= 0 && t.r <= 255 && t.g >= 0 && t.g <= 255 && t.b >= 0 && t.b <= 255 && (!t.hasOwnProperty("a") || t.a >= 0 && t.a <= 255);
        }, this.gradient = function (e) {
          return o.default.createGradient(e, {
            mixColors: t.mix,
            defaultColor: f
          });
        }, this.gradientData = function (t, e) {
          return e = e || f, new l.default(t, e);
        }, this.draw = function (e, r) {
          var n = (0, s.getCanvasGradient)(t, r),
            a = (0, s.getCanvasTarget)(e);
          if (a && n) {
            for (var u = a.width, o = a.height, i = a.getContext("2d"), l = i.createImageData(u, o), f = l.data.buffer, c = new Uint32Array(f), d = new Uint8ClampedArray(f), h = 0; h < u; h++) for (var p = 0; p < o; p++) c[p * u + h] = t.to.intabgr(n(h, p));
            l.data.set(d), i.putImageData(l, 0, 0);
          }
        }, this.hueColors = function () {
          return [{
            a: 255,
            b: 0,
            g: 0,
            r: 255
          }, {
            a: 255,
            b: 0,
            g: 255,
            r: 255
          }, {
            a: 255,
            b: 0,
            g: 255,
            r: 0
          }, {
            a: 255,
            b: 255,
            g: 255,
            r: 0
          }, {
            a: 255,
            b: 255,
            g: 0,
            r: 0
          }, {
            a: 255,
            b: 255,
            g: 0,
            r: 255
          }, {
            a: 255,
            b: 0,
            g: 0,
            r: 255
          }];
        }, this.hue = function (e) {
          var r = o.default.partialGradient(c.hueColors(), c.to.hsv(e).h);
          return t.mix(r.item1, r.item2, r.position);
        }, this.mix = function (t, e, r) {
          return {
            r: t.r - r * (t.r - e.r),
            g: t.g - r * (t.g - e.g),
            b: t.b - r * (t.b - e.b),
            a: t.a - r * (t.a - e.a)
          };
        }, this.to = {
          int: function (t) {
            return t.r << 16 | t.g << 8 | t.b;
          },
          hex: function (t) {
            return "#" + (1 << 24 | t.r << 16 | t.g << 8 | t.b).toString(16).slice(1);
          },
          cssrgb: function (t) {
            return "rgb(" + Math.round(t.r) + "," + Math.round(t.g) + "," + Math.round(t.b) + ")";
          },
          cssrgba: function (t) {
            return "rgba(" + Math.round(t.r) + "," + Math.round(t.g) + "," + Math.round(t.b) + "," + t.a / 255 + ")";
          },
          uintabgr: function (t) {
            return (t.a << 24 | t.b << 16 | t.g << 8 | t.r) >>> 0;
          },
          uintabgrOpaque: function (t) {
            return (4278190080 | t.b << 16 | t.g << 8 | t.r) >>> 0;
          },
          uintrgba: function (t) {
            return (t.r << 24 | t.g << 16 | t.b << 8 | t.a) >>> 0;
          },
          intabgr: function (t) {
            return t.a << 24 | t.b << 16 | t.g << 8 | t.r;
          },
          intabgrOpaque: function (t) {
            return 4278190080 | t.b << 16 | t.g << 8 | t.r;
          },
          intrgba: function (t) {
            return t.r << 24 | t.g << 16 | t.b << 8 | t.a;
          },
          hsl: function (t) {
            var e = t.r,
              r = t.g,
              n = t.b,
              a = t.a;
            e /= 255, r /= 255, n /= 255, a = isNaN(parseInt(a)) ? 1 : a / 255;
            var u = Math.max(e, r, n),
              o = Math.min(e, r, n),
              i = u - o,
              l = (u + o) / 2,
              s = 0,
              f = 0;
            return i > 0 && (s = i / (1 - Math.abs(2 * l - 1)), n === u ? f = (e - r) / i + 4 : r === u ? f = (n - e) / i + 2 : e === u && (f = (r - n) / i + (r < n ? 6 : 0)) < 0 && (f += 360), f /= 6), {
              h: f,
              s: s,
              l: l,
              a: a
            };
          },
          hsv: function (t) {
            var e = t.r,
              r = t.g,
              n = t.b,
              a = t.a;
            e /= 255, r /= 255, n /= 255, a = isNaN(parseInt(a)) ? 1 : a / 255;
            var u = Math.max(e, r, n),
              o = Math.min(e, r, n),
              i = u - o,
              l = 0,
              s = 0;
            return i > 0 && (l = i / u, n === u ? s = (e - r) / i + 4 : r === u ? s = (n - e) / i + 2 : e === u && (s = (r - n) / i + (r < n ? 6 : 0)) < 0 && (s += 360), s /= 6), {
              h: s,
              s: l,
              v: u,
              a: a
            };
          }
        };
      }();
    e.default = c, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var a = r(0),
      u = n(a),
      o = r(9),
      i = n(o),
      l = r(3),
      s = n(l);
    e.default = new function () {
      var t = this,
        e = 2 * Math.PI;
      this.createGradient = function (e) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        e = e || {};
        var n = u.default.includes(["linear", "circular"], e.type) ? e.type : "linear",
          a = u.default.get(e, "verify", !1),
          o = (u.default.get(e, "validate", !0), e.onValidationComplete || u.default.noop),
          l = null,
          f = null;
        if (e.colors instanceof s.default) f = e.colors;else {
          var c = e.defaultColor || r.defaultColor;
          f = new s.default(e.colors, c);
        }
        a && f.verify();
        var d = f.matrix ? f.object2d : f.flat1d;
        o(d);
        var h = 0,
          p = 0;
        "circular" === n ? l = f.matrix ? t.circularMatrixGradient : t.circularGradient : (h = e.centerX || 0, p = e.centerY || 0, l = f.matrix ? t.linearMatrixGradient : t.linearGradient);
        var y = e.width || 100,
          v = e.height || 100,
          b = e.scaleX || e.scale || 1,
          g = e.scaleY || e.scale || 1,
          m = y * b,
          _ = v * g,
          x = e.translateX || 0,
          S = e.translateY || 0;
        "circular" === n && (b /= 2, g /= 2, m = y * b, _ = v * g, x *= 2, S *= 2), e.centralize ? ("linear" === n && (h = .5, p = .5), x = .5 / b + x - h, S = .5 / g + S - p) : (x -= h, S -= p);
        var w = {
          colors: d,
          centerX: h || 0,
          centerY: p || 0,
          translateX: x,
          translateY: S,
          rotation: e.rotation || 0,
          repeatX: e.repeatX || i.default.repeat,
          repeatY: e.repeatY || i.default.repeat,
          mixColors: r.mixColors
        };
        return function (t, e) {
          return l(t / m, e / _, w);
        };
      }, this.partialGradient = function (t, e) {
        var r = t.length - 1,
          n = e * r | 0,
          a = 1 / r * 1e3,
          u = 1e3 * e % a / a,
          o = t[n];
        return {
          item1: o,
          item2: void 0 !== t[n + 1] ? t[n + 1] : o,
          position: u
        };
      }, this.partialGradientWithStops = function (t, e, r) {
        for (var n = 0; t[n][r] < e;) n++;
        var a = void 0 !== t[n - 1] ? t[n - 1] : t[n],
          u = t[n],
          o = u[r] - a[r];
        return {
          item1: a,
          item2: u,
          position: (e - a[r]) / o || 0
        };
      }, this.linearGradient = function (r, n, a) {
        var u = a.rotation * e,
          o = Math.cos(u),
          i = Math.sin(u),
          l = r - a.centerX - a.translateX,
          s = n - a.centerY - a.translateY;
        r = a.repeatX(a.centerX + l * o - s * i);
        var f = t.partialGradientWithStops(a.colors, r, "x");
        return a.mixColors(f.item1, f.item2, f.position);
      }, this.linearMatrixGradient = function (r, n, a) {
        var u = a.rotation * e,
          o = Math.cos(u),
          i = Math.sin(u),
          l = r - a.centerX - a.translateX,
          s = n - a.centerY - a.translateY;
        r = a.repeatX(a.centerX + l * o - s * i), n = a.repeatY(a.centerY + l * i + s * o);
        var f = t.partialGradientWithStops(a.colors, n, "y"),
          c = t.partialGradientWithStops(f.item1.colors, r, "x"),
          d = t.partialGradientWithStops(f.item2.colors, r, "x"),
          h = a.mixColors(c.item1, c.item2, c.position),
          p = a.mixColors(d.item1, d.item2, d.position);
        return a.mixColors(h, p, f.position);
      }, this.circularGradient = function (r, n, a) {
        var u = a.translateX,
          o = a.translateY,
          i = a.repeatX((Math.atan2(o - n, u - r) + Math.PI) / e - a.rotation),
          l = t.partialGradientWithStops(a.colors, i, "x");
        return a.mixColors(l.item1, l.item2, l.position);
      }, this.circularMatrixGradient = function (r, n, a) {
        var u = a.translateX,
          o = a.translateY,
          i = u - r,
          l = o - n,
          s = a.repeatY(Math.sqrt(i * i + l * l)),
          f = a.repeatX((Math.atan2(l, i) + Math.PI) / e - a.rotation),
          c = t.partialGradientWithStops(a.colors, s, "y"),
          d = t.partialGradientWithStops(c.item1.colors, f, "x"),
          h = t.partialGradientWithStops(c.item2.colors, f, "x"),
          p = a.mixColors(d.item1, d.item2, d.position),
          y = a.mixColors(h.item1, h.item2, h.position);
        return a.mixColors(p, y, c.position);
      };
    }(), t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function a(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var u = function () {
        function t(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, r, n) {
          return r && t(e.prototype, r), n && t(e, n), e;
        };
      }(),
      o = r(0),
      i = n(o),
      l = r(13),
      s = n(l),
      f = r(15),
      c = n(f),
      d = r(12),
      h = n(d),
      p = r(14),
      y = n(p),
      v = [s.default, c.default, h.default, y.default],
      b = function () {
        function t(e, r) {
          if (a(this, t), !Array.isArray(e) || !e.length) throw new Error("GradientData: Argument should be and array with at least one item.");
          if (this.dataType = this._getDataTypeFromFirstSample(e), !this.dataType) throw new Error("GradientData: One sample was tested and it did not match any supported data structures.");
          this.data = e, this.defaultColor = r;
        }
        return u(t, [{
          key: "typeName",
          get: function () {
            return this.dataType.name;
          }
        }, {
          key: "matrix",
          get: function () {
            return this.dataType.matrix;
          }
        }, {
          key: "flat1d",
          get: function () {
            if (!i.default.has(this.dataType, "toFlat1d")) {
              return new t(this.dataType.toObject2d(this.data, this.defaultColor), this.defaultColor).flat1d;
            }
            return this.dataType.toFlat1d(this.data, this.defaultColor);
          }
        }, {
          key: "flat2d",
          get: function () {
            if (!i.default.has(this.dataType, "toFlat2d")) {
              return new t(this.dataType.toObject2d(this.data, this.defaultColor), this.defaultColor).flat2d;
            }
            return this.dataType.toFlat2d(this.data, this.defaultColor);
          }
        }, {
          key: "array2d",
          get: function () {
            if (!i.default.has(this.dataType, "toArray2d")) {
              return new t(this.dataType.toObject2d(this.data, this.defaultColor), this.defaultColor).array2d;
            }
            return this.dataType.toArray2d(this.data, this.defaultColor);
          }
        }, {
          key: "object2d",
          get: function () {
            return this.dataType.toObject2d(this.data, this.defaultColor);
          }
        }], [{
          key: "types",
          get: function () {
            return v;
          }
        }]), u(t, [{
          key: "verify",
          value: function () {
            return this.dataType.verify(this.data);
          }
        }, {
          key: "_getDataTypeFromFirstSample",
          value: function (t) {
            return i.default.find(v, function (e) {
              return e.testStructure(t);
            });
          }
        }]), t;
      }();
    e.default = b, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var a = function () {
        function t(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, r, n) {
          return r && t(e.prototype, r), n && t(e, n), e;
        };
      }(),
      u = r(0),
      o = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(u),
      i = function () {
        function t() {
          n(this, t);
        }
        return a(t, null, [{
          key: "addDefaultColorsForMatrix",
          value: function (t, e) {
            var r = o.default.keys(e);
            o.default.forEach(t, function (t) {
              o.default.forEach(t.colors, function (t) {
                o.default.forEach(r, function (r) {
                  o.default.has(t, r) || (t[r] = e[r]);
                });
              });
            });
          }
        }, {
          key: "addDefaultColors",
          value: function (t, e) {
            var r = o.default.keys(e);
            o.default.forEach(t, function (t) {
              o.default.forEach(r, function (r) {
                o.default.has(t, r) || (t[r] = e[r]);
              });
            });
          }
        }, {
          key: "verify",
          value: function (t, e) {
            if (!this._verifyExpectedDataStructureInAllSamples(t, e)) throw new Error("Color data structure is not consistent / valid");
            return !0;
          }
        }, {
          key: "_verifyExpectedDataStructureInAllSamples",
          value: function (t, e) {
            for (var r = 0; r < t.length; r++) {
              var n = t[r];
              if (!e.testStructureSingleSample(n)) return !1;
            }
            return !0;
          }
        }, {
          key: "addMissingStopsXY",
          value: function (t) {
            var e = this;
            return t = this.addMissingStops(t, "y"), o.default.forEach(t, function (t) {
              t.colors = e.addMissingStops(t.colors, "x");
            }), t;
          }
        }, {
          key: "addMissingStops",
          value: function (t, e) {
            t = o.default.clone(t), 1 === t.length && (delete t[0][e], t.push(o.default.clone(t[0])));
            var r = o.default.findPropertyIndex(t, e),
              n = t[0],
              a = void 0;
            r > 0 || -1 === r ? n[e] = 0 : 0 !== n[e] && (a = o.default.clone(n), a[e] = 0, t.unshift(a));
            var u = o.default.findLastPropertyIndex(t, e),
              i = t[t.length - 1];
            u < t.length - 1 ? i[e] = 1 : 1 !== i[e] && (a = o.default.clone(i), a[e] = 1, t.push(a));
            for (var l = 0, s = 0; s > -1;) l = o.default.findPropertyIndex(t, e, l), s = o.default.findPropertyIndex(t, e, l + 1), s > -1 && this._addStopsBetweenIndexes(t, e, l, s), l = s;
            return t;
          }
        }, {
          key: "_addStopsBetweenIndexes",
          value: function (t, e, r, n) {
            for (var a = t[r][e], u = t[n][e], o = n - r, i = (u - a) / o, l = 1; l < o; l++) t[r + l][e] = a + l * i;
          }
        }]), t;
      }();
    e.default = i, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = Array(t.length); e < t.length; e++) r[e] = t[e];
        return r;
      }
      return Array.from(t);
    }
    function a(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var u = function () {
        function t(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, r, n) {
          return r && t(e.prototype, r), n && t(e, n), e;
        };
      }(),
      o = r(0),
      i = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(o),
      l = function () {
        function t() {
          a(this, t);
        }
        return u(t, null, [{
          key: "convert",
          value: function (t) {
            for (var e = this, r = arguments.length, n = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) n[a - 1] = arguments[a];
            return Array.isArray(t) ? t.map(function (t) {
              return e.convert.apply(e, [t].concat(n));
            }) : n.reduce(function (t, e) {
              return e(t);
            }, t);
          }
        }, {
          key: "convertAny",
          value: function (t, e, r) {
            var a = this.getColorType(t, r);
            if (!a || a === e) return t;
            if ("function" == typeof a.to[e.name]) return a.to[e.name](t);
            var u = this._getConversionPathThroughParentType(a, e, r);
            return this.convert.apply(this, [t].concat(n(u)));
          }
        }, {
          key: "getColorType",
          value: function (t, e) {
            return i.default.find(e, function (e) {
              return e.test(t);
            });
          }
        }, {
          key: "_getConversionPathThroughParentType",
          value: function (t, e, r) {
            var n = this._getPathToRoot(t),
              a = this._getPathToRoot(e).reverse(),
              u = n[n.length - 1],
              o = a[0],
              l = u === o,
              s = "function" == typeof u.to[o.name];
            if (l) a.shift();else if (!s) throw new Error("Path should be implemented from " + u.name + " to " + o.name);
            var f = n.concat(a),
              c = [],
              d = void 0;
            return i.default.forEach(f, function (t, e) {
              (d = f[e + 1]) && c.push(t.to[d.name]);
            }), c;
          }
        }, {
          key: "_getPathToRoot",
          value: function (t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
            return e.push(t), t.parent ? this._getPathToRoot(t.parent, e) : e;
          }
        }]), t;
      }();
    e.default = l, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function a(t, e, r) {
      return {
        h: t.h - r * (t.h - e.h),
        s: t.s - r * (t.s - e.s),
        l: t.l - r * (t.l - e.l),
        a: t.a - r * (t.a - e.a)
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      },
      o = r(1),
      i = n(o),
      l = r(2),
      s = n(l),
      f = r(3),
      c = n(f),
      d = r(7),
      h = {
        h: 0,
        s: 0,
        l: 0,
        a: 1
      },
      p = new function () {
        var t = this;
        this.name = "hsl", this.className = "Hsl", this.parent = null, this.test = function (t) {
          return null !== t && "object" === (void 0 === t ? "undefined" : u(t)) && t.hasOwnProperty("h") && t.hasOwnProperty("s") && t.hasOwnProperty("l") && t.h >= 0 && t.h <= 1 && t.s >= 0 && t.s <= 1 && t.l >= 0 && t.l <= 1 && (!t.hasOwnProperty("a") || t.a >= 0 && t.a <= 1);
        }, this.gradient = function (t) {
          return s.default.createGradient(t, {
            mixColors: a,
            defaultColor: h
          });
        }, this.gradientData = function (t, e) {
          return e = e || h, new c.default(t, e);
        }, this.draw = function (e, r) {
          var n = (0, d.getCanvasGradient)(t, r),
            a = (0, d.getCanvasTarget)(e);
          if (a && n) {
            for (var u = a.width, o = a.height, l = a.getContext("2d"), s = l.createImageData(u, o), f = s.data.buffer, c = new Uint32Array(f), h = new Uint8ClampedArray(f), p = 0; p < u; p++) for (var y = 0; y < o; y++) {
              var v = n(p, y),
                b = t.to.rgb(v);
              c[y * u + p] = i.default.to.intabgr(b);
            }
            s.data.set(h), l.putImageData(s, 0, 0);
          }
        }, this.to = {
          rgb: function (t) {
            var e = t.h,
              r = t.s,
              n = t.l,
              a = t.a,
              u = (1 - Math.abs(2 * n - 1)) * r,
              o = u * (1 - Math.abs(6 * e % 2 - 1)),
              i = n - u / 2,
              l = void 0,
              s = void 0,
              f = void 0;
            return e < 1 / 6 ? (l = u, s = o, f = 0) : e < 2 / 6 ? (l = o, s = u, f = 0) : e < .5 ? (l = 0, s = u, f = o) : e < 4 / 6 ? (l = 0, s = o, f = u) : e < 5 / 6 ? (l = o, s = 0, f = u) : (l = u, s = 0, f = o), {
              r: 255 * (l + i),
              g: 255 * (s + i),
              b: 255 * (f + i),
              a: void 0 === a ? 255 : 255 * a
            };
          },
          hsv: function (t) {
            var e = t.h,
              r = t.s,
              n = t.l,
              a = t.a,
              u = (2 * n + r * (1 - Math.abs(2 * n - 1))) / 2;
            return r = 2 * (u - n) / u, {
              h: e,
              s: r,
              v: u,
              a: void 0 === a ? 1 : a
            };
          },
          csshsl: function (t) {
            return "hsl(" + Math.round(360 * t.h) + "," + Math.round(100 * t.s) + "%," + Math.round(100 * t.l) + "%)";
          },
          csshsla: function (t) {
            return "hsla(" + Math.round(360 * t.h) + "," + Math.round(100 * t.s) + "%," + Math.round(100 * t.l) + "%," + t.a + ")";
          }
        };
      }();
    e.default = p, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getCanvasTarget = e.getCanvasGradient = void 0;
    var n = r(0),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n),
      u = function (t, e) {
        return a.default.isObject(e) ? t.gradient(e) : "function" == typeof e ? e : null;
      },
      o = function t(e) {
        if (e instanceof HTMLCanvasElement) return e;
        if ("string" == typeof e) {
          return t(document.querySelector(e));
        }
        return null;
      };
    e.getCanvasGradient = u, e.getCanvasTarget = o;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.TYPES_ALL = e.TYPES = void 0;
    var a = r(1),
      u = n(a),
      o = r(23),
      i = n(o),
      l = r(21),
      s = n(l),
      f = r(19),
      c = n(f),
      d = r(20),
      h = n(d),
      p = r(6),
      y = n(p),
      v = r(17),
      b = n(v),
      g = r(18),
      m = n(g),
      _ = r(22),
      x = n(_),
      S = r(24),
      w = n(S),
      M = r(25),
      O = n(M),
      C = [u.default, i.default, s.default, y.default, x.default, h.default, c.default, m.default, b.default],
      P = C.concat([w.default, O.default]);
    e.TYPES = C, e.TYPES_ALL = P;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = {
      none: function (t) {
        return t;
      },
      stop: function (t) {
        return t < 0 ? 0 : t > 1 ? 1 : t;
      },
      repeat: function (t) {
        return t < 0 ? 1 + t % 1 : t > 1 ? t % 1 : t;
      }
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var a = r(5),
      u = n(a),
      o = r(2),
      i = (n(o), r(9)),
      l = n(i),
      s = r(11),
      f = n(s),
      c = r(0),
      d = n(c),
      h = r(16),
      p = n(h),
      y = r(8),
      v = function () {
        var t = new ArrayBuffer(2),
          e = new Uint8Array(t),
          r = new Uint16Array(t);
        return e[0] = 170, e[1] = 187, 48042 === r[0] ? 0 : 43707 === r[0] ? 1 : UNKNOW_ENDIAN;
      }(),
      b = {
        any: p.default,
        endian: v,
        convert: u.default.convert,
        colorType: function (t) {
          return u.default.getColorType(t, y.TYPES);
        },
        repeat: l.default,
        color: function (t) {
          return new f.default(t);
        }
      };
    d.default.forEach(y.TYPES_ALL, function (t) {
      b[t.name] = t;
    }), e.default = b, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function a(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var u = function () {
        function t(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, r, n) {
          return r && t(e.prototype, r), n && t(e, n), e;
        };
      }(),
      o = r(8),
      i = r(1),
      l = n(i),
      s = r(2),
      f = n(s),
      c = r(5),
      d = n(c),
      h = r(0),
      p = n(h),
      y = function () {
        function t(e) {
          if (a(this, t), e instanceof t) this._primaryColor = p.default.clone(e._primaryColor), this._cache = this._cloneCache(e);else {
            var r = d.default.getColorType(e, o.TYPES);
            r || (r = "Rgb", e = {
              r: 0,
              g: 0,
              b: 0,
              a: 255
            }), this._primaryColor = e, this._cache = {}, this._cache[r.name] = e;
          }
        }
        return u(t, [{
          key: "clone",
          value: function () {
            return new t(this);
          }
        }, {
          key: "hueFromColor",
          value: function (e) {
            var r = this.hsv;
            return r.h = new t(e).hsv.h, new t(r);
          }
        }, {
          key: "hueFromValue",
          value: function (e) {
            var r = this.hsv;
            return r.h = e > 1 ? 1 : e < 0 ? 0 : e, new t(r);
          }
        }, {
          key: "hue",
          value: function () {
            var e = this;
            return this._cacheValue("hue", function () {
              var r = f.default.partialGradient(l.default.hueColors(), e.hsv.h);
              return new t(l.default.mix(r.item1, r.item2, r.position));
            }), this._cache.hue;
          }
        }]), t;
      }();
    y.prototype._cacheValue = function (t, e) {
      if (!p.default.has(this._cache, t)) {
        var r = e();
        this._cache[t] = r;
      }
    }, y.prototype._cloneCache = function (t) {
      var e = t._cache.hue,
        r = p.default.clone(t._cache);
      return e && (r.hue = e.clone()), r;
    }, p.default.forEach(o.TYPES, function (t) {
      var e = t.name;
      Object.defineProperty(y.prototype, e, {
        get: function () {
          var r = this;
          return this._cacheValue(e, function () {
            return d.default.convertAny(r._primaryColor, t, o.TYPES);
          }), this._cache[e];
        }
      });
    }), e.default = y, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function a(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var u = function () {
        function t(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, r, n) {
          return r && t(e.prototype, r), n && t(e, n), e;
        };
      }(),
      o = r(0),
      i = n(o),
      l = r(4),
      s = n(l),
      f = function () {
        function t() {
          a(this, t);
        }
        return u(t, null, [{
          key: "testStructure",
          value: function (t) {
            var e = i.default.get(t, "0");
            return this.testStructureSingleSample(e);
          }
        }, {
          key: "verify",
          value: function (t) {
            return s.default.verify(t, this);
          }
        }, {
          key: "testStructureSingleSample",
          value: function (t) {
            var e = t,
              r = Array.isArray(t) && e.length > 0;
            if (!r) return !1;
            for (var n = 0; n < e.length; n++) {
              var a = e[n];
              if (!(r = i.default.isObject(a))) return !1;
            }
            return !0;
          }
        }, {
          key: "toObject2d",
          value: function (t, e) {
            var r = t.map(function (t) {
              var e = {};
              return i.default.isNumber(t.y) && (e.y = t.y), e.colors = t, e;
            });
            return r = s.default.addMissingStopsXY(r), s.default.addDefaultColorsForMatrix(r, e), r;
          }
        }, {
          key: "name",
          get: function () {
            return "array2d";
          }
        }, {
          key: "matrix",
          get: function () {
            return !0;
          }
        }]), t;
      }();
    e.default = f, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function a(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var u = function () {
        function t(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, r, n) {
          return r && t(e.prototype, r), n && t(e, n), e;
        };
      }(),
      o = r(0),
      i = n(o),
      l = r(4),
      s = n(l),
      f = function () {
        function t() {
          a(this, t);
        }
        return u(t, null, [{
          key: "testStructure",
          value: function (t) {
            var e = i.default.get(t, "0");
            return this.testStructureSingleSample(e) && this._testStructureAllSamples(t);
          }
        }, {
          key: "verify",
          value: function (t) {
            return s.default.verify(t, this);
          }
        }, {
          key: "testStructureSingleSample",
          value: function (t) {
            return i.default.isObject(t) && !i.default.has(t, "colors");
          }
        }, {
          key: "_testStructureAllSamples",
          value: function (t) {
            return -1 === i.default.findPropertyIndex(t, "y");
          }
        }, {
          key: "toFlat1d",
          value: function (t, e) {
            var r = s.default.addMissingStops(t, "x");
            return s.default.addDefaultColors(r, e), r;
          }
        }, {
          key: "toObject2d",
          value: function (t, e) {
            var r = this.toFlat1d(t, e);
            return [{
              y: 0,
              colors: r
            }, {
              y: 1,
              colors: r
            }];
          }
        }, {
          key: "name",
          get: function () {
            return "flat1d";
          }
        }, {
          key: "matrix",
          get: function () {
            return !1;
          }
        }]), t;
      }();
    e.default = f, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function a(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var u = function () {
        function t(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, r, n) {
          return r && t(e.prototype, r), n && t(e, n), e;
        };
      }(),
      o = r(0),
      i = n(o),
      l = r(4),
      s = n(l),
      f = function () {
        function t() {
          a(this, t);
        }
        return u(t, null, [{
          key: "testStructure",
          value: function (t) {
            var e = i.default.get(t, "0");
            return this.testStructureSingleSample(e) && this._testStructureAllSamples(t);
          }
        }, {
          key: "verify",
          value: function (t) {
            return s.default.verify(t, this);
          }
        }, {
          key: "testStructureSingleSample",
          value: function (t) {
            return i.default.isObject(t) && !i.default.has(t, "colors");
          }
        }, {
          key: "_testStructureAllSamples",
          value: function (t) {
            return i.default.findPropertyIndex(t, "y") > -1;
          }
        }, {
          key: "toObject2d",
          value: function (t, e) {
            t = i.default.clone(t);
            var r = [],
              n = 0,
              a = void 0;
            return i.default.forEach(t, function (t) {
              a = i.default.isNumber(t.y) ? t.y : n;
              var e = i.default.find(r, ["y", a]);
              e ? e.colors.push(t) : r.push({
                y: a,
                colors: [t]
              }), n = a, delete t.y;
            }), r = s.default.addMissingStopsXY(r), s.default.addDefaultColorsForMatrix(r, e), r;
          }
        }, {
          key: "name",
          get: function () {
            return "flat2d";
          }
        }, {
          key: "matrix",
          get: function () {
            return !0;
          }
        }]), t;
      }();
    e.default = f, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function a(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var u = function () {
        function t(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, r, n) {
          return r && t(e.prototype, r), n && t(e, n), e;
        };
      }(),
      o = r(0),
      i = n(o),
      l = r(4),
      s = n(l),
      f = function () {
        function t() {
          a(this, t);
        }
        return u(t, null, [{
          key: "testStructure",
          value: function (t) {
            var e = i.default.get(t, "0");
            return this.testStructureSingleSample(e);
          }
        }, {
          key: "verify",
          value: function (t) {
            return s.default.verify(t, this);
          }
        }, {
          key: "testStructureSingleSample",
          value: function (t) {
            var e = i.default.get(t, "colors"),
              r = i.default.isObject(t) && Array.isArray(e);
            if (!r) return !1;
            if (e.length < 1) return !1;
            for (var n = 0; n < e.length; n++) {
              var a = e[n];
              if (!(r = i.default.isObject(a))) return !1;
            }
            return !0;
          }
        }, {
          key: "toObject2d",
          value: function (t, e) {
            var r = s.default.addMissingStopsXY(t);
            return s.default.addDefaultColorsForMatrix(r, e), r;
          }
        }, {
          key: "toFlat1d",
          value: function (t, e) {
            var r = this.toObject2d(t, e),
              n = [];
            return i.default.forEach(r, function (t) {
              i.default.forEach(t.colors, function (t) {
                delete t.x, n.push(t);
              });
            }), n;
          }
        }, {
          key: "toArray2d",
          value: function (t, e) {
            var r = this.toObject2d(t, e);
            return i.default.map(r, "colors");
          }
        }, {
          key: "toFlat2d",
          value: function (t, e) {
            var r = this.toObject2d(t, e),
              n = [];
            return i.default.forEach(r, function (t) {
              var e = t.y;
              i.default.forEach(t.colors, function (t) {
                t.y = e, n.push(t);
              });
            }), n;
          }
        }, {
          key: "name",
          get: function () {
            return "object2d";
          }
        }, {
          key: "matrix",
          get: function () {
            return !0;
          }
        }]), t;
      }();
    e.default = f, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var a = r(0),
      u = n(a),
      o = r(5),
      i = n(o),
      l = r(8),
      s = {
        to: {}
      };
    u.default.forEach(l.TYPES, function (t) {
      var e = u.default.lowerFirst(t.name);
      s.to[e] = function (e) {
        return i.default.convertAny(e, t, l.TYPES);
      };
    }), e.default = s, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = function () {
        function t(t, e) {
          var r = [],
            n = !0,
            a = !1,
            u = void 0;
          try {
            for (var o, i = t[Symbol.iterator](); !(n = (o = i.next()).done) && (r.push(o.value), !e || r.length !== e); n = !0);
          } catch (t) {
            a = !0, u = t;
          } finally {
            try {
              !n && i.return && i.return();
            } finally {
              if (a) throw u;
            }
          }
          return r;
        }
        return function (e, r) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return t(e, r);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
      a = r(6),
      u = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(a),
      o = /^hsla?\s*\(\s*(\d{1,3}\s*)\s*,\s*(\d{1,3}\s*)(%)\s*,\s*(\d{1,3}\s*)(%)\s*\)$/;
    e.default = {
      name: "csshsl",
      className: "Csshsl",
      parent: u.default,
      test: function (t) {
        return "string" == typeof t && !!o.exec(t);
      },
      to: {
        hsl: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
            r = o.exec(t) || [],
            a = n(r, 5),
            u = a[0],
            i = a[1],
            l = a[2],
            s = (a[3], a[4]);
          return u ? {
            h: parseInt(i) / 360,
            s: parseInt(l) / 100,
            l: parseInt(s) / 100,
            a: e
          } : null;
        }
      }
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = function () {
        function t(t, e) {
          var r = [],
            n = !0,
            a = !1,
            u = void 0;
          try {
            for (var o, i = t[Symbol.iterator](); !(n = (o = i.next()).done) && (r.push(o.value), !e || r.length !== e); n = !0);
          } catch (t) {
            a = !0, u = t;
          } finally {
            try {
              !n && i.return && i.return();
            } finally {
              if (a) throw u;
            }
          }
          return r;
        }
        return function (e, r) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return t(e, r);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
      a = r(6),
      u = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(a),
      o = /^hsla?\s*\(\s*(\d{1,3}\s*)\s*,\s*(\d{1,3}\s*)(%)\s*,\s*(\d{1,3}\s*)(%)\s*,\s*(\d*\.?\d*)\s*\)$/;
    e.default = {
      name: "csshsla",
      className: "Csshsla",
      parent: u.default,
      test: function (t) {
        return "string" == typeof t && !!o.exec(t);
      },
      to: {
        hsl: function (t) {
          var e = o.exec(t) || [],
            r = n(e, 7),
            a = r[0],
            u = r[1],
            i = r[2],
            l = (r[3], r[4]),
            s = (r[5], r[6]);
          return a ? {
            h: parseInt(u) / 360,
            s: parseInt(i) / 100,
            l: parseInt(l) / 100,
            a: s ? parseFloat(s) : 1
          } : null;
        }
      }
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = function () {
        function t(t, e) {
          var r = [],
            n = !0,
            a = !1,
            u = void 0;
          try {
            for (var o, i = t[Symbol.iterator](); !(n = (o = i.next()).done) && (r.push(o.value), !e || r.length !== e); n = !0);
          } catch (t) {
            a = !0, u = t;
          } finally {
            try {
              !n && i.return && i.return();
            } finally {
              if (a) throw u;
            }
          }
          return r;
        }
        return function (e, r) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return t(e, r);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
      a = r(1),
      u = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(a),
      o = /^rgba?\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
    e.default = {
      name: "cssrgb",
      className: "Cssrgb",
      parent: u.default,
      test: function (t) {
        return "string" == typeof t && !!o.exec(t);
      },
      to: {
        rgb: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 255,
            r = o.exec(t) || [],
            a = n(r, 4),
            u = a[0],
            i = a[1],
            l = a[2],
            s = a[3];
          return u ? {
            r: parseInt(i),
            g: parseInt(l),
            b: parseInt(s),
            a: e
          } : null;
        },
        int: function (t) {
          var e = o.exec(t) || [],
            r = n(e, 4),
            a = r[0],
            u = r[1],
            i = r[2],
            l = r[3];
          return a ? (parseInt(u) << 16) + (parseInt(i) << 8) + parseInt(l) : null;
        },
        hex: function (t) {
          var e = o.exec(t) || [],
            r = n(e, 4),
            a = r[0],
            u = r[1],
            i = r[2],
            l = r[3];
          return a ? "#" + ((1 << 24) + (parseInt(u) << 16) + (parseInt(i) << 8) + parseInt(l)).toString(16).slice(1) : null;
        }
      }
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = function () {
        function t(t, e) {
          var r = [],
            n = !0,
            a = !1,
            u = void 0;
          try {
            for (var o, i = t[Symbol.iterator](); !(n = (o = i.next()).done) && (r.push(o.value), !e || r.length !== e); n = !0);
          } catch (t) {
            a = !0, u = t;
          } finally {
            try {
              !n && i.return && i.return();
            } finally {
              if (a) throw u;
            }
          }
          return r;
        }
        return function (e, r) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return t(e, r);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
      a = r(1),
      u = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(a),
      o = /^rgba?\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d*\.?\d*)\s*\)$/;
    e.default = {
      name: "cssrgba",
      className: "Cssrgba",
      parent: u.default,
      test: function (t) {
        return "string" == typeof t && !!o.exec(t);
      },
      to: {
        rgb: function (t) {
          var e = o.exec(t) || [],
            r = n(e, 5),
            a = r[0],
            u = r[1],
            i = r[2],
            l = r[3],
            s = r[4];
          return a ? {
            r: parseInt(u),
            g: parseInt(i),
            b: parseInt(l),
            a: s ? 255 * parseFloat(s) | 0 : 255
          } : null;
        },
        int: function (t) {
          var e = o.exec(t) || [],
            r = n(e, 4),
            a = r[0],
            u = r[1],
            i = r[2],
            l = r[3];
          return a ? (parseInt(u) << 16) + (parseInt(i) << 8) + parseInt(l) : null;
        },
        hex: function (t) {
          var e = o.exec(t) || [],
            r = n(e, 4),
            a = r[0],
            u = r[1],
            i = r[2],
            l = r[3];
          return a ? "#" + ((1 << 24) + (parseInt(u) << 16) + (parseInt(i) << 8) + parseInt(l)).toString(16).slice(1) : null;
        }
      }
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = function () {
        function t(t, e) {
          var r = [],
            n = !0,
            a = !1,
            u = void 0;
          try {
            for (var o, i = t[Symbol.iterator](); !(n = (o = i.next()).done) && (r.push(o.value), !e || r.length !== e); n = !0);
          } catch (t) {
            a = !0, u = t;
          } finally {
            try {
              !n && i.return && i.return();
            } finally {
              if (a) throw u;
            }
          }
          return r;
        }
        return function (e, r) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return t(e, r);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
      a = r(1),
      u = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(a),
      o = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      i = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
    e.default = {
      name: "hex",
      className: "Hex",
      parent: u.default,
      test: function (t) {
        return "string" == typeof t && !(!i.exec(t) && !o.exec(t));
      },
      to: {
        rgb: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 255;
          t = t.replace(o, function (t, e, r, n) {
            return e + e + r + r + n + n;
          });
          var r = i.exec(t) || [],
            a = n(r, 4),
            u = a[0],
            l = a[1],
            s = a[2],
            f = a[3];
          return u ? {
            r: parseInt(l, 16),
            g: parseInt(s, 16),
            b: parseInt(f, 16),
            a: e
          } : null;
        },
        int: function (t) {
          return parseInt(t.replace(o, function (t, e, r, n) {
            return e + e + r + r + n + n;
          }).replace("#", ""), 16);
        },
        cssrgb: function (t) {
          t = t.replace(o, function (t, e, r, n) {
            return e + e + r + r + n + n;
          });
          var e = i.exec(t) || [],
            r = n(e, 4),
            a = r[0],
            u = r[1],
            l = r[2],
            s = r[3];
          return a ? "rgb(" + parseInt(u, 16) + "," + parseInt(l, 16) + "," + parseInt(s, 16) + ")" : null;
        },
        cssrgba: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          t = t.replace(o, function (t, e, r, n) {
            return e + e + r + r + n + n;
          });
          var r = i.exec(t) || [],
            a = n(r, 4),
            u = a[0],
            l = a[1],
            s = a[2],
            f = a[3];
          return u ? "rgba(" + parseInt(l, 16) + "," + parseInt(s, 16) + "," + parseInt(f, 16) + "," + e + ")" : null;
        }
      }
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function a(t, e, r) {
      return {
        h: t.h - r * (t.h - e.h),
        s: t.s - r * (t.s - e.s),
        v: t.v - r * (t.v - e.v),
        a: t.a - r * (t.a - e.a)
      };
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      },
      o = r(1),
      i = n(o),
      l = r(2),
      s = n(l),
      f = r(3),
      c = n(f),
      d = r(7),
      h = {
        h: 0,
        s: 0,
        v: 0,
        a: 1
      },
      p = new function () {
        var t = this;
        this.name = "hsv", this.className = "Hsv", this.parent = null, this.test = function (t) {
          return null !== t && "object" === (void 0 === t ? "undefined" : u(t)) && t.hasOwnProperty("h") && t.hasOwnProperty("s") && t.hasOwnProperty("v") && t.h >= 0 && t.h <= 1 && t.s >= 0 && t.s <= 1 && t.v >= 0 && t.v <= 1 && (!t.hasOwnProperty("a") || t.a >= 0 && t.a <= 1);
        }, this.gradient = function (t) {
          return s.default.createGradient(t, {
            mixColors: a,
            defaultColor: h
          });
        }, this.gradientData = function (t, e) {
          return e = e || h, new c.default(t, e);
        }, this.draw = function (e, r) {
          var n = (0, d.getCanvasGradient)(t, r),
            a = (0, d.getCanvasTarget)(e);
          if (a && n) {
            for (var u = a.width, o = a.height, l = a.getContext("2d"), s = l.createImageData(u, o), f = s.data.buffer, c = new Uint32Array(f), h = new Uint8ClampedArray(f), p = 0; p < u; p++) for (var y = 0; y < o; y++) {
              var v = n(p, y),
                b = t.to.rgb(v);
              c[y * u + p] = i.default.to.intabgr(b);
            }
            s.data.set(h), l.putImageData(s, 0, 0);
          }
        }, this.to = {
          rgb: function (t) {
            var e = t.h,
              r = t.s,
              n = t.v,
              a = t.a,
              u = n * r,
              o = u * (1 - Math.abs(6 * e % 2 - 1)),
              i = n - u,
              l = void 0,
              s = void 0,
              f = void 0;
            return e < 1 / 6 ? (l = u, s = o, f = 0) : e < 2 / 6 ? (l = o, s = u, f = 0) : e < .5 ? (l = 0, s = u, f = o) : e < 4 / 6 ? (l = 0, s = o, f = u) : e < 5 / 6 ? (l = o, s = 0, f = u) : (l = u, s = 0, f = o), {
              r: 255 * (l + i),
              g: 255 * (s + i),
              b: 255 * (f + i),
              a: isNaN(parseFloat(a)) ? 255 : 255 * a
            };
          },
          hsl: function (t) {
            var e = t.h,
              r = t.s,
              n = t.v,
              a = t.a,
              u = .5 * n * (2 - r);
            return r = n * r / (1 - Math.abs(2 * u - 1)), {
              h: e,
              s: r,
              l: u,
              a: void 0 === a ? 1 : a
            };
          }
        };
      }();
    e.default = p, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(1),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n);
    e.default = {
      name: "int",
      className: "Int",
      parent: a.default,
      test: function (t) {
        return "number" == typeof t && t <= 16777215 && t >= 0;
      },
      to: {
        rgb: function (t) {
          return {
            r: (16711680 & t) >> 16,
            g: (65280 & t) >> 8,
            b: 255 & t,
            a: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 255
          };
        },
        hex: function (t) {
          return "#" + ((1 << 24) + t).toString(16).slice(1);
        },
        cssrgb: function (t) {
          return "rgb(" + ((16711680 & t) >> 16) + "," + ((65280 & t) >> 8) + "," + (255 & t) + ")";
        },
        cssrgba: function (t) {
          return "rgba(" + ((16711680 & t) >> 16) + "," + ((65280 & t) >> 8) + "," + (255 & t) + "," + (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1) + ")";
        }
      }
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(1),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n);
    e.default = {
      name: "intabgr",
      className: "Intabgr",
      parent: a.default,
      to: {
        rgb: function (t) {
          return {
            a: t >> 24 & 255,
            b: t >> 16 & 255,
            g: t >> 8 & 255,
            r: 255 & t
          };
        }
      }
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(1),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(n);
    e.default = {
      name: "intrgba",
      className: "Intrgba",
      parent: a.default,
      to: {
        rgb: function (t) {
          return {
            r: t >> 24 & 255,
            g: t >> 16 & 255,
            b: t >> 8 & 255,
            a: 255 & t
          };
        }
      }
    }, t.exports = e.default;
  }, function (t, e, r) {
    t.exports = r(10);
  }]);
});